import { render, staticRenderFns } from "./UserHistorical.vue?vue&type=template&id=2a5f63e6&scoped=true&"
import script from "./UserHistorical.vue?vue&type=script&lang=js&"
export * from "./UserHistorical.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5f63e6",
  null
  
)

export default component.exports